import { render, staticRenderFns } from "./InventoryEditItemOverlay.vue?vue&type=template&id=dfe9058a&"
import script from "./InventoryEditItemOverlay.vue?vue&type=script&lang=ts&"
export * from "./InventoryEditItemOverlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports